import { Column } from '@tanstack/react-table';
import { useMemo } from 'react';
import Select from 'react-select';
import classNames from 'classnames';
import CustomReactSelectNoOptions from '@components/primitives/form/components/CustomReactSelectNoOptions';
import { useTranslation } from 'react-i18next';

export type SelectFilterValue = Array<string> | undefined;

interface Props<TData> {
    column: Column<TData>;
}

const SelectFilter = <TData extends object>({ column }: Props<TData>) => {
    const columnFilterValue = column.getFilterValue() as SelectFilterValue;
    const { t } = useTranslation();

    const sortedUniqueValues = useMemo(() => {
        return Array.from(column.getFacetedUniqueValues().keys()).sort().slice(0, 5000);
    }, [column.getFacetedUniqueValues()]);

    return (
        <div
            className={classNames('gridFilter', 'gridFilter--select', {
                'gridFilter--active': columnFilterValue?.length,
            })}
        >
            <Select
                menuPosition="fixed"
                className="form__select"
                classNamePrefix="form__select"
                options={sortedUniqueValues.map((value) => ({ value, label: value ? value : t('gridFilters.select.emptyOption', { ns: 'dataGrid' }) }))}
                isMulti
                placeholder=""
                noOptionsMessage={() => <CustomReactSelectNoOptions />}
                onChange={(selectedOptions) => {
                    if (selectedOptions.length === 0) {
                        column.setFilterValue(undefined);
                        return;
                    }

                    column.setFilterValue(selectedOptions.map((option) => option.value));
                }}
                value={columnFilterValue ? columnFilterValue.map((value) => ({ value, label: value ? value : t('gridFilters.select.emptyOption', { ns: 'dataGrid' }) })) : []}
            />
        </div>
    );
};

export default SelectFilter;
